import z from "zod";

export const baseUser = z.object({
    id: z.string().min(1, { message: "Invalid ID" }),
    email: z.string().email("invalid Email"),
    password: z
        .string()
        .min(8, { message: "Password must be at least 8 characters long" })
        .regex(/\d/, { message: "Password must contain at least one number" }),
    name: z.string().min(2),
    position: z.string(),
    image: z.string().nullable(),
    role: z.string().nullable(),
    department: z.string(),
    emailVerified: z.boolean(),
    twoFactorEnabled: z.boolean().nullable(),
    banReason: z.string().nullable(),
    banned: z.boolean().nullable(),
    banExpires: z.date().nullable(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});

export const user = baseUser;

export const authenticatedUser = user.omit({
    password: true,
});

export const findUser = user.omit({
    password: true,
}).extend({
    authSource: z.string().optional(),
});

export const findUsers = z.array(findUser);

export const paginatedFindUsers = z.object({
    data: findUsers,
    count: z.number(),
});

export const paginatedFindUsersFilters = z.object({
    page: z.coerce.number().default(1),
    per_page: z.coerce.number().default(10),
    email: z.string().nullish(),
});

export const createUser = baseUser.omit({ id: true, createdAt: true, updatedAt: true });

export const updateUser = baseUser
    .extend({
        password: z
            .string()
            .optional()
            .transform((e) => (e === "" ? undefined : e))
            .or(
                z
                .string()
                .min(8, { message: "Password must be at least 8 characters long" })
                .regex(/\d/, { message: "Password must contain at least one number" })
            ),
        position: z.string().optional(),
        department: z.string().optional(),
    })
    .omit({ createdAt: true, updatedAt: true});

export const deleteUsers = z.object({
    ids: z.string().array().min(1),
});

export const userValidator = {
    createUser,
    updateUser,
    deleteUsers,
    findUser,
    findUsers,
    paginatedFindUsers,
    paginatedFindUsersFilters,
    user,
    authenticatedUser,
    baseUser,
};
